import CalendarItem from "./CalendarItem";
import DateUtils from "../utils/Date.utils";

export default class CalendarItems {
  private data: Map<String, CalendarItem>;
  private ids: string[];

  constructor(items?: CalendarItem[] | undefined) {
    this.data = new Map();
    this.ids = [];
    if (items) {
      items.forEach(i => {
        this.ids.push(i.id);
        this.data.set(i.id, i);
      });
    }
  }

  add(item: CalendarItem) {
    const id = item.id;
    this.data.set(id, item);
    if (this.ids.indexOf(id) === -1) {
      this.ids.push(id);
    }
  }

  filter<T>(filterFunction: (arg: CalendarItem) => boolean): CalendarItems {
    return new CalendarItems(Array.from(this.data.values()).filter(filterFunction));
  }

  map<T>(mapFunction: (arg: CalendarItem) => T): T[] {
    return Array.from(this.data.values()).map(mapFunction);
  }

  static empty() {
    return new CalendarItems();
  }

  addAll(items: CalendarItem[]) {
    items.forEach((i) => this.add(i));
  }

  getForThisWeek() {
    return this.filter(item => DateUtils.isInRange(item.date, 0, 7));
  }

  getForNextWeek() {
    return this.filter(item => DateUtils.isInRange(item.date, 7, 1000));
  }

  isEmpty() {
    return this.ids.length === 0;
  }
}
